module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_ZAHNMUND-hauptseite-hintergrund.ee3be071.jpg";